import React, { PureComponent } from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Chip, Grid, Checkbox, Tooltip } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { expansionStyles } from './style';
import AddIcon from '@material-ui/icons/Add';
import { MyPATLink, MyPATGlobalLoader, MyPATLocalLoader } from '../../../common';
import { dialogTopNav } from '../../../content-request/styles/dialogTopNav';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import ToggleInput from '../../../common/ToggleInput';
import { TYPECODE } from '../treeComponents/component/helpers/myLibraryFunctions';
import { HIDE_TEST_POPUP_INFO } from '../../Constants/constants';

interface ExpansionPanelComponentProps extends WithStyles<typeof expansionStyles> {
  classes: any;
  data?: any;
  name?: string;
  isDeleted?: boolean;
  isAddContentRequired?: boolean;
  isAddBonusContentRequired?: boolean;
  toggleOpenMyLibrary?: Function;
  toggleAddBonusContent?: Function;
  handleDeleteContent?: Function;
  bulkDragDetails?: boolean;
  bulkDrag: any;
  conceptPhaseData: any;
  handleOnChangeCheckBox: any;
  isExpansionPanelOpen?: boolean;
  isBulkDataAdded?: boolean;
  isChapterLevel?:boolean;
  handleTestVisibilityToggle?: Function;
  showTestVisibility?: boolean;
}

interface ExpansionPanelComponentStates {
  expanded: boolean;
  deleteLoader: boolean;
}
class ExpansionPanelComponent extends PureComponent<ExpansionPanelComponentProps, ExpansionPanelComponentStates> {
  constructor(props: ExpansionPanelComponentProps) {
    super(props);
    this.state = {
      expanded: false,
      deleteLoader: false,
    };
  }

  componentDidMount = () => {
    const { isExpansionPanelOpen = false } = this.props;
    if (isExpansionPanelOpen) {
      this.onClickExpansion();
    }
  };

  componentDidUpdate = (prevProps: ExpansionPanelComponentProps) => {
    if (this.props.isExpansionPanelOpen !== prevProps.isExpansionPanelOpen) {
      this.onClickExpansion();
    }
  };
  onClickExpansion = () => {
    this.setState((prevState: ExpansionPanelComponentStates) => ({
      expanded: !prevState.expanded,
    }));
  };
  getImage = (type: string) => {
    switch (type) {
      case 'studymaterial':
        return <img src='/assets/svg/contentRequest/study.svg' alt='studyMaterial-icon' />;
      case 'studyNotes':
        return <img src='/assets/svg/myLibrary/notes.svg' alt='notes-icon' />;
      case 'video':
        return <img src='/assets/svg/myLibrary/Video.svg' alt='video-icon' />;
      case 'formula':
        return <img src='/assets/svg/myLibrary/formulas.svg' alt='formula-icon' />;
      case 'test':
        return <img src='/assets/svg/myLibrary/test.svg' alt='test-icon' />;
      case 'testpapers':
        return <img src='/assets/svg/myLibrary/test.svg' alt='test-icon' />;
      case 'question':
        return <img src='/assets/svg/myLibrary/question.svg' alt='question-icon' />;
      default:
        return <img src='' alt='icon' />;
    }
  };

  getLink = (type: string, id: string) => {
    switch (type) {
      case 'test':
        return `/content/preview/${id}testpapers`;
      case 'studyNotes':
        return `/content/preview/${id}note`;
      case 'video':
        return `/content/preview/${id}videos`;
      case 'formula':
        return `/content/preview/${id}formulas`;
      default:
        return '';
    }
  };

  handleDeleteContent = (element: any) => {
    const { handleDeleteContent } = this.props;
    this.setState({
      deleteLoader: true
    }, () => {
      setTimeout(() => {
        handleDeleteContent && handleDeleteContent(element)
        this.setState({ deleteLoader: false })
      }, 200)
    })

  }

  changeTestVisibilityToggle = (element: any, toggleValue: any) => {
    const { handleTestVisibilityToggle } = this.props;
    handleTestVisibilityToggle && handleTestVisibilityToggle(element, toggleValue);
  };

  render = () => {
    const {
      classes,
      data = [],
      name = '',
      handleDeleteContent,
      isDeleted,
      isAddContentRequired,
      isAddBonusContentRequired,
      toggleOpenMyLibrary,
      toggleAddBonusContent,
      isBulkDataAdded,
      conceptPhaseData,
      isChapterLevel,
      showTestVisibility,
    } = this.props;
    
    return (
      <div className={classes.root}>
        {data && !Boolean(data.length) ? (
          <div className={classes.customExpension}>
            <ExpansionPanel classes={{ expanded: classes.expansionPanelExpanded }}>
              <ExpansionPanelSummary
                classes={{
                  root: classes.rootcls,
                  expanded: classes.expansionPanelSummaryExpanded,
                  content: classes.expansionPanelSummaryContent,
                }}
                expandIcon={<ExpandMoreIcon />}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <div>{name && <Typography className={classes.heading}>{name}</Typography>}</div>
                  {this.props.bulkDragDetails && (
                    <div className={classes.actionCTA}>
                      <span>
                        <Checkbox
                          color='primary'
                          classes={{
                            root: classes.checkBoxElement,
                            checked: classes.checkedCheckbox,
                          }}
                          checked={
                            this.props.bulkDrag[
                            `concept-${this.props.conceptPhaseData.phaseIndex}-${
                            this.props.conceptPhaseData.weekIndex
                            }-${this.props.conceptPhaseData.subjectIndex}-${
                            this.props.conceptPhaseData.chapterIndex
                            }-${this.props.conceptPhaseData.conceptIndex}`
                            ]
                          }
                          onClick={(e: any) =>
                            this.props.handleOnChangeCheckBox(
                              e,
                              `concept-${this.props.conceptPhaseData.phaseIndex}-${
                              this.props.conceptPhaseData.weekIndex
                              }-${this.props.conceptPhaseData.subjectIndex}-${
                              this.props.conceptPhaseData.chapterIndex
                              }-${this.props.conceptPhaseData.conceptIndex}`
                            )
                          }
                        />
                      </span>
                    </div>
                  )}
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails style={{ paddingBottom: '0' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                    textAlign: 'center',
                    width: '100%',
                  }}
                >
                  <span>
                    <Typography className={classes.noContentTitle}>Content not added Yet!</Typography>
                  </span>
                  <span className={classes.noContentTxt}>
                    Plan your course by adding study material and test for selected {isChapterLevel?"chapter":"concept"}
                </span>
                  <span>
                    {isAddContentRequired && (
                      <Tooltip title='Add content from this concept' placement="bottom-end">
                        <Button
                          variant='contained'
                          color='primary'
                          onClick={() =>{
                                 return toggleOpenMyLibrary && toggleOpenMyLibrary(false,isChapterLevel);
                                }}
                        >
                          <AddIcon />
                          Add Content
                    </Button>
                      </Tooltip>
                    )}
                  </span>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        ) : (
            <ExpansionPanel
              classes={{ expanded: classes.expansionPanelExpanded }}
              expanded={this.state.expanded}
              onChange={this.onClickExpansion}
            >
              <ExpansionPanelSummary
                classes={{
                  root: classes.rootcls,
                  expanded: classes.expansionPanelSummaryExpanded,
                  content: classes.expansionPanelSummaryContent,
                }}
                expandIcon={<ExpandMoreIcon />}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>{name && <Typography className={classes.heading}>{name}</Typography>}</div>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails style={{ paddingBottom: '0' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                    width: '100%',
                  }}
                >
                  <div className={classes.actionCTA1}>
                    <span>
                      {isAddContentRequired && (
                        <Button color='primary' onClick={() =>{
                          return toggleOpenMyLibrary && toggleOpenMyLibrary(false,isChapterLevel);
                         }}>
                          <AddIcon />
                          Add Content
                    </Button>
                      )}
                    </span>
                    <span>
                      {isAddBonusContentRequired && (
                        <>
                          <Button
                            className={classes.padding0}
                            color='primary'
                            onClick={() => toggleAddBonusContent && toggleAddBonusContent(isChapterLevel)}
                          >
                            <AddIcon /> Add Bonus Content
                      </Button>
                          <CustomInfoIcon
                            infoDialogContentType='Add Bonus Content'
                            isCenterArrow={true}
                            isRightArrow={false}
                            isInfoIcon={true}
                            knowMoreAbout={false}
                            dialogTitle='Add Bonus Content'
                            imageURL='/assets/svg/addBonus.svg'
                            dialogPara='Additional content for students scoring the desired proficiency'
                            details='Click to know more'
                            toolTipDirection='top'
                          />
                        </>
                      )}
                    </span>
                    {this.props.bulkDragDetails && (
                      <span>
                        <Checkbox
                          classes={{
                            root: classes.checkBoxElement,
                            checked: classes.checkedCheckbox,
                          }}
                          color='primary'
                          checked={
                            this.props.bulkDrag[
                            `concept-${this.props.conceptPhaseData.phaseIndex}-${
                            this.props.conceptPhaseData.weekIndex
                            }-${this.props.conceptPhaseData.subjectIndex}-${this.props.conceptPhaseData.chapterIndex}-${
                            this.props.conceptPhaseData.conceptIndex
                            }`
                            ]
                          }
                          onChange={(e: any) =>
                            this.props.handleOnChangeCheckBox(
                              e,
                              `concept-${this.props.conceptPhaseData.phaseIndex}-${
                              this.props.conceptPhaseData.weekIndex
                              }-${this.props.conceptPhaseData.subjectIndex}-${this.props.conceptPhaseData.chapterIndex}-${
                              this.props.conceptPhaseData.conceptIndex
                              }`
                            )
                          }
                        />
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }} className={classes.expentionMain}>
                    {data &&
                      Boolean(data.length) &&
                      data.map((element: any) => (
                        <>
                        {!this.state.deleteLoader ? (
                          <Grid container justify='space-between' className={classes.borderBottomGray}>
                          <Grid item >
                            <div className={classes.subImage}>

                              {<div style={{ position: 'relative' }}>
                                {element.isBulkDataAdded && <span className={classes.redDot} />}
                                {
                                  this.getImage(element.type)
                                }</div>}
                              &nbsp;
                        <MyPATLink
                                style={{ position: 'relative' }}
                                to={this.getLink(element.type, element.id)}
                                target='_blank'
                              >
                                <Tooltip title= {`${element.title} ${ element.contentId ? ` | ${element.contentId}` : ''}`}>
                                  <span className={classes.subName} style={{ color: 'blue' }}>
                                    {`${element.title} ${ element.contentId ? ` | ${element.contentId}` : ''}`}
                                  </span>
                                </Tooltip>
                              </MyPATLink>
                            </div>
                          </Grid>
                          <Grid item>
                            {element && element.isBonus && (
                              <Typography className={classes.proficiency}>
                                At least{' '}
                                {element.bonusCriteria && element.bonusCriteria.length && element.bonusCriteria[0].value}%
                                &nbsp;
                            {element.bonusCriteria &&
                                  element.bonusCriteria.length &&
                                  element.bonusCriteria[0].name}{' '}
                                required
                          </Typography>
                            )}
                          </Grid>
                          <Grid item>
                            {element && element.isBonus && (
                              <Chip classes={{ root: classes.chipUI }} label='Bonus Content' />
                            )}
                          </Grid>
                          <Grid item  style={{ display: "flex" }}>
                            {showTestVisibility && element && element.type === TYPECODE.TEST && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                Hide Test <CustomInfoIcon
                                  infoDialogContentType='Hide Test'
                                  isCenterArrow={true}
                                  isRightArrow={false}
                                  isInfoIcon={true}
                                  knowMoreAbout={false}
                                  dialogTitle='Hide Test'
                                  dialogPara={HIDE_TEST_POPUP_INFO}
                                  details='Click to know more'
                                  toolTipDirection='top'
                                />
                                <ToggleInput
                                  disabled={!isDeleted}
                                  isChecked={element.testDetails.isHidden}
                                  handleToggle={(event: any) => this.changeTestVisibilityToggle(element,event)}
                                />
                              </div>
                            )}
                            {isDeleted && (
                              <Button style={{ marginRight: '3px' }} onClick={() => this.handleDeleteContent(element)}>
                                {' '}
                                <img src='/assets/svg/delete.svg' className={classes.grayIcon} />
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                        ): (<MyPATLocalLoader />) }
                        </>
                      ))}
                  </div>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          )}
      </div>
    );
  };
}

export default withStyles(
  expansionStyles
  //@ts-ignore
)(ExpansionPanelComponent);
